import { render } from "./PublicPolicyDisplay.vue?vue&type=template&id=73eb65e7&scoped=true"
import script from "./PublicPolicyDisplay.vue?vue&type=script&lang=js"
export * from "./PublicPolicyDisplay.vue?vue&type=script&lang=js"

import "./PublicPolicyDisplay.vue?vue&type=style&index=0&id=73eb65e7&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73eb65e7"]])

export default __exports__